<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
  >
    <path d="M32,2C14.88,2,1,15.88,1,33s13.88,31,31,31,31-13.87,31-31S49.12,2,32,2h0Z" />
    <path
      fill="#fff"
      d="M32,4.5c15.71,0,28.5,12.79,28.5,28.5s-12.78,28.5-28.5,28.5S3.5,48.71,3.5,33,16.28,4.5,32,4.5Z"
    />
    <path d="M32,7c-14.34,0-26,11.66-26,26s11.66,26,26,26,26-11.66,26-26S46.34,7,32,7h0Z" />
    <g>
      <polygon
        fill="#fff"
        points="40.08 28.24 47.63 42.79 43.19 51.22 40.08 51.22 40.08 28.24"
      />
      <polygon
        fill="#fff"
        points="38.56 25.31 38.56 51.22 25.44 51.22 25.44 25.3 32 12.65 38.56 25.31"
      />
      <polygon
        fill="#fff"
        points="23.92 28.24 23.92 51.22 20.8 51.22 16.37 42.79 23.92 28.24"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'CircleIcon',
};
</script>
